import { createEntityExtension } from "../mystekz-linked-entities";
import { DomainsManager } from "./manager";
import { LinkedEntity } from "../mystekz-linked-entities";
import { type DomainInTree } from "@/stores/domains-store";
import { h } from "vue";
import { vnodeToHtml } from "@/utils";
import GenericCard from "@/components/EntityInfo/GenericCard.vue";
import { EntityType } from "@/stores/entity-store";

export type DomainEntity = LinkedEntity<"domain", DomainInTree>;

let domainsManager: DomainsManager;
/**
 * Get the business entity manager for a given domain.
 */
export const getDomainesManager = (baseUrl: string) => {
    if (!domainsManager) {
        domainsManager = new DomainsManager(baseUrl);
    }
    return domainsManager;
};

export const DomainsExtension = createEntityExtension(
    "domain",
    import.meta.env.VITE_BASE_URL,
    true,
    {
        popup: {
            key: "domainDetails",
            hover: true,
            create: (_: Promise<DomainEntity | void>, entityId: string) => {
                return () => {
                    return vnodeToHtml(
                        h(GenericCard, {
                            entityId,
                            entityType: EntityType.DOMAIN,
                        })
                    );
                };
            },
        },
        prefix: "",
    },
    {
        popup: {
            key: "domainInsert",
        },
    },
    getDomainesManager,
    {
        label: "Domains",
        showInInlineMenu: true,
        caret: true,
        icon: {
            name: "pi-cloud",
            library: "primeicons",
        },
        group: "Linked Entities",
    }
);
